export enum ResourceSubtitle {
  NONE = 'none',
  INCLUDED = 'included',
  PRICE = 'price',
}
